<template>
<div :id="tabid" class="song-list-container">
    <header-trending v-if="layout == 'trending'" class="row m-h--5 m-b-0 m-t-8"></header-trending>

    <div class="row song-list m-h--5">
        <div class="col-xs-12">
            
            <div class="row">
                <song-widget v-if="i > Math.round(currentWidget/8)*8 - 10 && i < Math.round(currentWidget/8)*8 + 10" v-for="(song, i) in songs" :key="song.id" :song="song" :index="i+1" :class="{'no-transition': 10 == 10, 'last': i == songs.length-1, 'last-loaded':  i == songs.length-1 }" origin="home.Suggestion Box"></song-widget>
                <div v-else class="song-widget placeholder col-xs-6 p-h-5 no-transition">
                    <div class="inner-container"><loader size="128px"></loader></div>
                </div>
                
                <div v-if="loading">
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5 last last-loaded">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
 
export default {
    components: {
        'song-widget': require('@/components/Song/Widget/Suggestion.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: {
        tabid: { default: null },
        playlistName: { default: 'Suggestions' },
        layout: { default: 'default' },
        newSuggestions: { default: 0 }
    },

    data() {
        return {
            songs: null,
            loading: true,
            currentWidget: 0,
            scrollPosition: {
                left: 0,
            },
        }
    },

    activated(){
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;

        $(`#${this.tabid} .song-list`).scrollLeft(this.scrollPosition.left);
        this.currentWidget = Math.round(this.scrollPosition.left / wW);
    },

    mounted() {
        this.getSongs();

        var that = this;
        var scrollTimeout = false;
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;

        //horizontal
        $(`#${this.tabid} .song-list`).on('touchstart', function() {
            $(this).stop(true, true);
        }).on('scroll', function() {
            that.scrollPosition.left = $(this)[0].scrollLeft;
            that.currentWidget = Math.round($(this)[0].scrollLeft / wW);

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                $(this).stop(true, true).animate({ scrollLeft: that.currentWidget * wW }, 250);
            }, 250);
        });
    },

    methods: {
        getSongs(append = false) {
            this.loading = true;
            this.$http.get(this.getEndpoint).then((success) => {
                this.songs = success.data.data;
                this.loading = false;

                //cleared viewed/new
                var ids = [];
                $.each(this.songs, (i, s) => { if (s.viewed == 0) ids.push(s.id); });
                if (ids.length){
                    this.$http.post(this.getViewedEndpoint, { ids : ids });
                }

                //update badges
                this.$root.$emit('suggestions-badges', {action: 'set', value: 0});
            })
        },

        isSong(entry) {
            return entry.suggestable_type == 'App\\Song';
        },

        isPlaylist(entry) {
            return entry.suggestable_type == 'App\\Playlist';
        },
    },

    computed: {
        getEndpoint() {
            return App.restApi + '/api/v2/suggestions';
        },

        getViewedEndpoint() {
            return App.restApi + '/api/v2/suggestions/not-viewed';
        }   
    },

    watch: {
        newSuggestions() {
            if (this.newSuggestions){
                this.songs = [];
                this.getSongs();
            }
        }
    }
}
</script>